import { render } from "./UnidadesNegocio.vue?vue&type=template&id=379d0f22"
import script from "./UnidadesNegocio.vue?vue&type=script&lang=js"
export * from "./UnidadesNegocio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__